import React from 'react'
import { Outlet, ScrollRestoration, useNavigate } from 'react-router-dom'
import { LDProvider } from 'launchdarkly-react-client-sdk'

import { LOGIN_PATH } from '../../../routes/LoginRoutes'
import { PrefetchingProvider } from '../../../utils/Prefetching/PrefetchingContext'
import { PrivateRouteContainer } from './PrivateRoute.styles'
import useFirebaseAuthentication from '../../../utils/Firebase/hooks/useFirebaseAuthentication'
import { NotificationProvider } from '../../Notification/NotificationContext'
import { Button, Stack } from '@mui/material'
import TermsProvider from '../../Terms/TermsContext'
import { getLaunchDarklyClient, LDConfig } from '../../../config/launchDarkly'
import CircularProgress from '@mui/material/CircularProgress'
import { useActionFetchUser } from '../../../store/hooks/user/useActionFetchUser'

export default function PrivateRoute() {
	const { loading, authUser } = useFirebaseAuthentication()
	const navigate = useNavigate()
	const { loading: loadingUserData } = useActionFetchUser()

	if (loading || loadingUserData) {
		return (
			<Stack justifyContent="center" height="100vh" alignItems="center">
				<CircularProgress />
			</Stack>
		)
	}

	if (authUser) {
		return (
			<LDProvider
				clientSideID={LDConfig.clientSideID}
				reactOptions={LDConfig.reactOptions}
				ldClient={getLaunchDarklyClient()}
				context={{ ...LDConfig.context, email: authUser?.email }}
			>
				<NotificationProvider>
					<TermsProvider>
						<PrefetchingProvider>
							<ScrollRestoration />
							<Outlet />
						</PrefetchingProvider>
					</TermsProvider>
				</NotificationProvider>
			</LDProvider>
		)
	}

	return (
		<PrivateRouteContainer>
			<h1>You must be logged in to access this page</h1>
			<p>Log in or sign up to continue</p>
			<Button variant="contained" onClick={() => navigate(LOGIN_PATH)}>
				Log in
			</Button>
		</PrivateRouteContainer>
	)
}
